<template>
  <v-navigation-drawer
    app
    :value="true"
    :mobile-breakpoint="0"
    :mini-variant="minimized"
    style="height: calc(100vh - 30px)"
  >
    <div class="h-full d-flex flex-column">
      <div class="d-flex align-center pa-3 gap-2 w-full">
        <BaseAvatar
          :src="user.photo"
          :seed="user.userId"
          :size="minimized ? 32 : 38"
        />
        <template v-if="!minimized">
          <div class="flex-grow-1">
            <h6 class="mb-0 lh-1">{{ user.name }}</h6>
            <small>{{ user.document }}</small>
          </div>
          <v-btn icon small @click="$emit('logout')">
            <v-icon small>mdi-logout</v-icon>
          </v-btn>
        </template>
      </div>

      <v-divider></v-divider>
      <div class="pa-3 py-1 d-flex justify-space-between flex-wrap gap-y-1">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click="minimized = !minimized"
            >
              <v-icon>
                mdi-{{
                  minimized ? "arrow-right-bold-box" : "arrow-left-bold-box"
                }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{ minimized ? "Mostrar" : "Ocultar" }} barra</span>
        </v-tooltip>
        <v-tooltip top v-if="!inElectronApp">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="toggleFullscreen">
              <v-icon>
                mdi-{{ fullscreen ? "fullscreen-exit" : "fullscreen" }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{ fullscreen ? "Sair da tela cheia" : "Tela cheia" }}</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="toggleDarkMode">
              <v-icon>{{
                $vuetify.theme.dark
                  ? "mdi-lightbulb-on-outline"
                  : "mdi-moon-waning-crescent"
              }}</v-icon>
            </v-btn>
          </template>
          {{ $vuetify.theme.dark ? "Modo claro" : "Modo escuro" }}
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click="$root.$emit('calculator')"
            >
              <v-icon>mdi-calculator</v-icon>
            </v-btn>
          </template>
          <span>Calculadora</span>
        </v-tooltip>

        <!-- <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click="$emit('update:privacyMode', !privacyMode)"
            >
              <v-icon>mdi-{{ privacyMode ? "eye-off" : "eye" }}</v-icon>
            </v-btn>
          </template>
          <span>{{ privacyMode ? "Mostrar valores" : "Ofuscar valores" }}</span>
        </v-tooltip> -->

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-chart-line</v-icon>
            </v-btn>
          </template>
          <span>Relatórios</span>
        </v-tooltip>
      </div>
      <v-divider></v-divider>

      <div
        v-show="!minimized"
        style="height: calc(100vh - 106px - 32px - 75px)"
        class="pt-4"
      >
        <p class="mx-4 lh-1 font-weight-bold">Histórico de Vendas</p>
        <vue-perfect-scrollbar
          :settings="{ suppressScrollX: true, wheelPropagation: false }"
          style="height: calc(100% - 32px)"
        >
          <HistorySideBar :token="token" />
        </vue-perfect-scrollbar>
      </div>

      <v-divider class="mt-auto" />
      <v-card
        @click="$root.$emit('qz-tray-config')"
        class="ma-3"
        elevation="0"
        rounded="lg"
        outlined
      >
        <v-alert
          :type="isConnected ? 'success' : 'error'"
          :icon="isConnected ? 'mdi-printer-check' : 'mdi-printer-off'"
          dense
          text
          class="ma-0"
          :class="{
            'pa-1': minimized,
            'pa-2': !minimized,
          }"
        >
          <div class="d-flex flex-column" v-if="!minimized">
            <b class="text-12">
              {{ isConnected ? "Conectada" : "Desconectada" }}
            </b>
            <p class="mb-0 text-10">
              {{
                isConnected
                  ? "A impressora está pronta para uso."
                  : "Clique para configurar a impressora."
              }}
              <!-- Clique para configurar. -->
            </p>
          </div>
        </v-alert>
      </v-card>
    </div>
  </v-navigation-drawer>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import HistorySideBar from "./HistorySideBar.vue";

export default {
  name: "LeftSideBar",
  components: {
    HistorySideBar,
  },
  data() {
    return {
      fullscreen: false,
      minimized: true,
    };
  },
  props: {
    token: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: false,
    },
    privacyMode: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    ...mapActions(["changeThemeDarkMode"]),
    toggleDarkMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      this.changeThemeDarkMode(this.$vuetify.theme.dark);
    },
    toggleFullscreen() {
      if (this.isFullscreen()) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          /* Firefox */
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          /* Chrome, Safari and Opera */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          /* IE/Edge */
          document.msExitFullscreen();
        }
        this.fullscreen = false;
      } else {
        const docElm = document.documentElement;
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen();
        } else if (docElm.mozRequestFullScreen) {
          /* Firefox */
          docElm.mozRequestFullScreen();
        } else if (docElm.webkitRequestFullscreen) {
          /* Chrome, Safari and Opera */
          docElm.webkitRequestFullscreen();
        } else if (docElm.msRequestFullscreen) {
          /* IE/Edge */
          docElm.msRequestFullscreen();
        }
        this.fullscreen = true;
      }
    },
    isFullscreen() {
      return !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      );
    },
    handleFullscreenChange() {
      this.fullscreen = this.isFullscreen();
    },
  },
  computed: {
    ...mapGetters("qz", ["isConnected"]),
    inElectronApp() {
      return !!(window && window.electronKiosk && window.electronKiosk.isApp);
    },
  },
  mounted() {
    this.fullscreen = this.isFullscreen();
    document.addEventListener("fullscreenchange", this.handleFullscreenChange);
    document.addEventListener(
      "webkitfullscreenchange",
      this.handleFullscreenChange
    );
    document.addEventListener(
      "mozfullscreenchange",
      this.handleFullscreenChange
    );
    document.addEventListener(
      "MSFullscreenChange",
      this.handleFullscreenChange
    );
  },
};
</script>
